/* eslint-disable import-x/no-extraneous-dependencies */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect, useMemo } from 'react';

import { getArrFromLocalStorage, setArrToLocalStorage } from '@vlabs/monokit/shared/lib/localStorage';
import { routes } from '@vlabs/shared/navigation/routes';
import { selectAppServices } from '@vlabs/shared/selectors/appSelectors';
import { selectListOptions } from '@vlabs/shared/selectors/listSelectors';
import { isVersionGte } from '@vlabs/shared/utils';
import { unset } from 'lodash';
import { useForm, FormProvider } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import nextId from 'react-id-generator';
import { connect, useSelector } from 'react-redux';
import {
  generatePath, useHistory, useParams, useLocation,
} from 'react-router-dom';
import { toast } from 'react-toastify';

import { selectHandlerOptions } from '@vlabs/pages/handlers/selectors';

import { defaultNotification, defaultVideoAnalytics } from '../defaultValues';
import st from './NotificationForm.module.sass';
import {
  EventRulesNotificationSubForm,
  VideoAnalyticsRulesNotificationSubForm,
  NotificationTypeSubForm,
  TelegramNotificationSubForm,
  UINotificationSubForm,
} from './sub-forms';
import { getNotification, updateNotification } from '../store';

export function NotificationFormComponent({
  needVA = true,
  setNotificationName = undefined,
  onSubmitNotification = undefined,
  listOptions = [],
  handlerOptions = [],
}) {
  const { t } = useTranslation();
  const history = useHistory();
  const location = useLocation();
  const { notificationId } = useParams();

  const [notification, setNotification] = useState(defaultNotification);
  const [type, setType] = useState();

  const VANotificationsArr = getArrFromLocalStorage('VANotificationsArr');

  const eventData = useMemo(() => ({
    ...notification,
    filters: {
      ...notification.filters,
      handlers: notification?.filters?.handlers?.map((handlerId) => handlerOptions
        ?.find(({ value }) => handlerId === value)),
      lists: notification?.filters?.lists?.map((listId) => listOptions
        ?.find(({ value }) => listId === value)),
    },
  }), [notification, handlerOptions, listOptions]);

  const vaData = useMemo(() => ({ ...notification }), [notification]);

  const form = useForm({ defaultValues: eventData });
  const { handleSubmit, watch, reset } = form;

  const filtersType = watch('filters.type')?.value;

  const { vlNotifier: { versionNum: version } } = useSelector(selectAppServices);
  const versionMoreThan0_1_6 = isVersionGte(version, {
    major: 0,
    minor: 1,
    patch: 6,
  });

  const formContext = {
    ...form,
    listOptions,
    handlerOptions,
    version,
    versionMoreThan0_1_6,
    notificationId,
    formType: type,
    needVA,
  };

  useEffect(() => {
    if (notificationId !== 'create') {
      setType(location.state?.eventType);
      if (type === 'events') {
        getNotification(notificationId).then(({ data }) => {
          setNotification(data);
        });
      }
      if (type === 'videoanalytics') {
        const currentVA = VANotificationsArr.find((va) => va.uuid === notificationId);
        setNotification(currentVA);
      }
    }
    if (notificationId === 'create') setType(filtersType);
  }, [notificationId, type, filtersType, location.state?.eventType]);

  useEffect(() => {
    if (notificationId !== 'create') {
      if (type === 'events') reset(eventData);
      if (type === 'videoanalytics') reset(vaData);
    }
    if (notificationId === 'create') {
      if (type === 'events') reset(defaultNotification);
      if (type === 'videoanalytics') reset(defaultVideoAnalytics);
    }
  }, [notificationId, eventData, vaData, type, reset]);

  useEffect(() => {
    setNotificationName(notification?.filters?.name);
  }, [notification]);

  const onSubmit = (data) => {
    if (type === 'events') {
      if (notificationId !== 'create' && !data.filters.age) {
        unset(data, 'filters.age__gte');
        unset(data, 'filters.age__lt');
      }
      if (notificationId === 'create') unset(data, 'filters.type');
      unset(data, 'ui.recipients');
      onSubmitNotification(notificationId, data, () => history.push(generatePath(routes.notifications.all)));
    }
    if (type === 'videoanalytics') {
      const newData = {
        ...data,
        uuid: notificationId === 'create' ? nextId() : data.uuid,
      };
      const newArr = notificationId === 'create'
        ? [...VANotificationsArr, newData]
        : [...VANotificationsArr].map((va) => (va.uuid === notificationId ? newData : va));
      setArrToLocalStorage('VANotificationsArr', newArr);
      toast.success(notificationId === 'create'
        ? t('vlNotifier:создание.успех')
        : t('vlNotifier:обновление.успех'));
      history.push(generatePath(routes.notifications.all));
    }
  };

  return (
    <FormProvider {...formContext}>
      <form
        id="NotificationForm"
        onSubmit={handleSubmit(onSubmit)}
      >
        <div className={st.NotificationContainer}>
          <div className={st.NotificationSettings}>
            <NotificationTypeSubForm />
            <div className={st.Separator} />
            {type === 'events'
              ? <EventRulesNotificationSubForm />
              : <VideoAnalyticsRulesNotificationSubForm />}
          </div>
          <div className={st.DisplayContainer}>
            <div className={st.NotificationSettings}>
              <TelegramNotificationSubForm />
            </div>
            <div className={st.NotificationSettings}>
              <UINotificationSubForm />
            </div>
          </div>
        </div>
      </form>
    </FormProvider>
  );
}

export const NotificationForm = connect(
  (state) => ({
    handlerOptions: selectHandlerOptions(state),
    listOptions: selectListOptions(state),
  }),
  (dispatch) => ({
    onSubmitNotification: (id, data, fanc) => dispatch(updateNotification(id, data, fanc)),
  }),
)(NotificationFormComponent);
